import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

import {HeaderService} from '@sharedcommon/services/header.service';
import {UserDto, UserServiceClient} from '@sharedcommon/rest/identity.restservice';
import {ValidationService} from '@sharedcommon/services/validation.service';
import {MatTab, MatTabGroup, MatTabHeader} from '@angular/material/tabs';

@Component({
  templateUrl: './account.page.html'
})
export class NeqAccountPage implements AfterViewInit {

  @ViewChild('tabs') tabs: MatTabGroup;

  currentUser: UserDto;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly userService: UserServiceClient,
    private readonly headerService: HeaderService,
    private readonly translationService: TranslateService,
    private readonly validationService: ValidationService
  ) {
  }

  ngAfterViewInit() {
    this.tabs._handleClick = this.checkChanges.bind(this);

    this.userService.getCurrentUser().subscribe(user => this.currentUser = user);

    this.headerService.setHeaderValues({
      basicLabel: this.translationService.instant('label.user.my-account'),
      showGoBack: true,
      redirectionRoute: this.route.parent.snapshot
    });
  }

  checkChanges(_tab: MatTab, _tabHeader: MatTabHeader, _idx: number) {
    const args = arguments;
    this.validationService.checkModifications(() => {
      MatTabGroup.prototype._handleClick.apply(this.tabs, args);
    });
  }
}
